import React, { FC, useEffect } from 'react';
import {
  getPharmacistReplacementDetails,
  pharmacistReplacementDetails,
  pharmacyActions,
} from '@pharmaplan/common';

import { useAppDispatch } from '../../hooks/useAppDispatch';
import { useAppSelector } from '../../hooks/useAppSelector';
import PharmacistCard from '../SelfService/PharmacistCard';
import { ScreenTypes } from '../../helpers/Constants';
import { renderScreen, setBack, setFooterShow } from '../../actions/drawerActions';

interface IPharmacistReplacementProfile {
  pharmacistId: string;
  isAutoSyncRecord?:boolean
}
const success = pharmacyActions.pharmacistReplacementDetails;

const PharmacistReplacementProfile: FC<IPharmacistReplacementProfile> = ({
  pharmacistId,
  isAutoSyncRecord,
}) => {
  const dispatch = useAppDispatch();
  const pharmacistDetails = useAppSelector(pharmacistReplacementDetails);

  useEffect(() => {
    dispatch(getPharmacistReplacementDetails({ id: pharmacistId, isAutoSyncRecord }));
    dispatch(setFooterShow(false));
    dispatch(setBack(null));
  }, []);

  const goBack = () => {
    dispatch(
      renderScreen({
        screenNumber: 1,
        screenType: ScreenTypes.replacement,
        pharmacistId,
      }),
    );
  };

  return (
    <PharmacistCard
      successAction={success}
      pharmacistDetails={pharmacistDetails}
      screenType={ScreenTypes.replacement}
      goBack={goBack}
    />
  );
};

export default PharmacistReplacementProfile;
